import { cx } from '@/utils/cx';
import { MarketIcon, OrdersIcon, ProfileIcon } from '@/assets/icons';
import { TABS } from '@/constants/tabs';
import type { TabKey } from '@/constants/tabs';
import styles from './TabBar.module.scss';

const TAB_ICONS: Record<TabKey, (props: { size?: number; className?: string }) => JSX.Element> = {
  market: MarketIcon,
  orders: OrdersIcon,
  profile: ProfileIcon,
};

export interface TabBarProps {
  active: TabKey;
  onChange: (tab: TabKey) => void;
}

export function TabBar({ active, onChange }: TabBarProps) {
  return (
    <nav className={styles.tabbar} aria-label="Primary">
      {TABS.map((tab) => {
        const Icon = TAB_ICONS[tab.key];
        const isActive = tab.key === active;
        return (
          <button
            key={tab.key}
            type="button"
            className={cx(styles.tab, isActive && styles.active)}
            aria-current={isActive ? 'page' : undefined}
            onClick={() => onChange(tab.key)}
          >
            <Icon size={22} />
            <span className={styles.label}>{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
